export const CONTACT_INFO = {
  street: "211 Ullamcorper St Roseville",
  email: "maestriartifex@gmail.com",
  phoneNo: "+40 712 345 678",
  socials: [
    { icon: "facebook-f", link: "/", location: "/" },
    { icon: "twitter", link: "/", location: "/" },
    { icon: "linkedin", link: "/", location: "/" },
    { icon: "instagram", link: "/", location: "/" },
  ],
};
